import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from './index';
import { AmendmentType, biData } from './types';

// First select the relevant part from the state
const selectDomain = (state: RootState) => state.biDetailState || initialState;

export const selectOACLNummber = createSelector(
  [selectDomain],
  state => state.oaclNumber,
);
export const selectCurrency = createSelector(
  [selectDomain],
  contractDataState => {
    const viewCurrency = contractDataState.biDetail?.view.contractInfo.contractCurrency ? contractDataState.biDetail?.view.contractInfo.contractCurrency : '';
    if (contractDataState.previewMode) {
      const lastAmendmentWithContractInfo = [...contractDataState.biDetail?.amendment || []].reverse().find(
        amendment => amendment.type === AmendmentType.BIUPDATE &&
        (amendment.relatedSections || {}).hasOwnProperty('contractInfo'));
      return (lastAmendmentWithContractInfo?.data as biData)?.contractInfo?.contractCurrency ?? viewCurrency;
    } else {
      return viewCurrency;
    }
  },
);
export const selectBiDetail = createSelector(
  [selectDomain],
  contractDataState => contractDataState.biDetail,
);
export const selectContractInfo = createSelector(
  [selectDomain],
  contractDataState => contractDataState.biDetail?.view.contractInfo,
);
export const selectRecurring = createSelector(
  [selectDomain],
  contractDataState => contractDataState.biDetail?.view.recurring,
);
export const selectPreviousRecurring = createSelector(
  [selectDomain],
  contractDataState => contractDataState.biDetail?.view.previousRecurring,
);
export const selectAllPreviousRecurring = createSelector(
  [selectDomain],
  contractDataState => contractDataState.previousRecurring,
)
export const selectOneOff = createSelector(
  [selectDomain],
  contractDataState => contractDataState.biDetail?.view.oneOff,
);
export const selectDeposit = createSelector(
  [selectDomain],
  contractDataState => contractDataState.biDetail?.view.deposit,
);
export const selectOtherReimbursement = createSelector(
  [selectDomain],
  contractDataState => contractDataState.biDetail?.view.otherReimbursement,
);
export const selectAmendment = createSelector(
  [selectDomain],
  contractDataState => contractDataState.biDetail?.amendment,
);
export const selectContractInfoView = createSelector(
  [selectDomain],
  contractDataState => contractDataState.contractInfoView,
);
export const selectRecurringView = createSelector(
  [selectDomain],
  contractDataState => contractDataState.recurringView,
);
export const selectOneOffView = createSelector(
  [selectDomain],
  contractDataState => contractDataState.oneOffView,
);
export const selectDepositView = createSelector(
  [selectDomain],
  contractDataState => contractDataState.depositView,
);
export const selectOriginalView = createSelector(
  [selectDomain],
  contractDataState => contractDataState.biDetail?.view,
);
export const selectPreviewMode = createSelector(
  [selectDomain],
  contractDataState => contractDataState.previewMode,
);
export const selectDisplayData = createSelector(
  [selectDomain],
  contractDataState => contractDataState.displayData,
);
export const selectContractError = createSelector(
  [selectDomain],
  contractDataState => contractDataState.error,
);
